import { JSX } from 'react';
import DashboardTile from '@app/shared/qes-standards/DashboardTile';
import { ProviderLandscapeMap } from '@app/overviews/market-expansion-dashboard/components/provider-landscape-map/ProviderLandscapeMap';

const ProviderLandscapeTile = (): JSX.Element => {
  return (
    <DashboardTile title={"Contract Entity Landscape"} widthClass="col-12" classNames="px-2">
      <ProviderLandscapeMap />
    </DashboardTile>
  );
}

export default ProviderLandscapeTile;